import { render, staticRenderFns } from "./nump3.vue?vue&type=template&id=233f2d39&scoped=true&"
import script from "./nump3.vue?vue&type=script&lang=js&"
export * from "./nump3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233f2d39",
  null
  
)

export default component.exports